<template>
  <div class="form-check">
    <label :for="inputId" class="p-label">{{ label }}</label>
    <PrimeVueCheckbox
      v-model="isChecked"
      :input-id="inputId"
      :name="name"
      binary
    />
  </div>
</template>

<script setup lang="ts">
import { useCompareListStore } from '~/stores/compareListStore/compareListStore';

export interface ProductComparisonProps {
  inputId: string;
  name: string;
  label: string;
  productUid: string;
}

const props = defineProps<ProductComparisonProps>();

const compareListStore = useCompareListStore();

const isChecked = computed({
  get() {
    return compareListStore.items.some((item) => {
      if (!item?.product?.uid) {
        return false;
      }

      // Direct comparison
      if (
        item.product.uid === props.productUid ||
        item.product.sku === props.productUid
      ) {
        return true;
      }

      // Try decoding base64 UID for comparison
      try {
        const decodedItemUid = atob(item.product.uid);
        const decodedPropUid = atob(props.productUid);
        return decodedItemUid === decodedPropUid;
      } catch {
        return false;
      }
    });
  },
  async set(value: boolean) {
    try {
      if (value) {
        await compareListStore.addProduct(props.productUid);
      } else {
        await compareListStore.removeProduct(props.productUid);
      }
    } catch (_) {
      // Error will be shown by useCompareToastNotifications
    }
  }
});
</script>
